import { Instance, types } from 'mobx-state-tree';

export const Route = types.model('RouteModel', {
  id: '',
  name: '',
  componentName: types.maybeNull(types.string),
  path: types.maybeNull(types.string),
  iconName: '',
  dummy: false,
  showInMenu: true,
  order: types.maybeNull(types.number),
  parent: types.maybeNull(
    types.model({
      id: '',
      name: '',
    }),
  ),
});

export type RouteType = Instance<typeof Route>;
